import { WarehouseItemWorkRequestRejectionReason } from "@redotech/cockroachdb-codegen/tables/fulfillment/warehouse-item-work-request-rejection-reason";
import { warehouseItemWorkRequestIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const rejectItemWorkRequest = {
  name: "rejectItemWorkRequest" as const,
  input: z.object({
    id: warehouseItemWorkRequestIdFormat.schema,
    reason: z.enum(WarehouseItemWorkRequestRejectionReason),
    note: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
